module.exports = __webpack_public_path__ + "static/arcelik-category-372eb6f02f3c77903cf12285f9638a12.webp";